/**
 * @generated SignedSource<<b78aceb44a8a4054d23d51500cd033c8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type helpersCheckIsOpinionArticle$data = {
  readonly types: ReadonlyArray<{
    readonly value: ReadonlyArray<{
      readonly entityId: string;
    } | null> | null;
  } | null> | null;
  readonly " $fragmentType": "helpersCheckIsOpinionArticle";
};
export type helpersCheckIsOpinionArticle$key = {
  readonly " $data"?: helpersCheckIsOpinionArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"helpersCheckIsOpinionArticle">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "helpersCheckIsOpinionArticle"
};

(node as any).hash = "3478c1f8f5d5935de82722e5a2cf973f";

export default node;
